import * as React from "react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-shire-light group-[.toaster]:text-shire-dark group-[.toaster]:border-shire-bark group-[.toaster]:border-2 group-[.toaster]:shadow-xl group-[.toaster]:shadow-shire-bark/10 group-[.toaster]:rounded-lg group-[.toaster]:font-body group-[.toaster]:backdrop-blur-sm",
          description: "group-[.toast]:text-shire-bark group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-shire-sun group-[.toast]:text-shire-dark group-[.toast]:border group-[.toast]:border-shire-bark group-[.toast]:rounded-md group-[.toast]:font-ui group-[.toast]:font-medium group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:transition-colors group-[.toast]:hover:bg-shire-bark group-[.toast]:hover:text-shire-light",
          cancelButton:
            "group-[.toast]:bg-shire-stone group-[.toast]:text-shire-dark group-[.toast]:border group-[.toast]:border-shire-bark/50 group-[.toast]:rounded-md group-[.toast]:font-ui group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:transition-colors group-[.toast]:hover:bg-shire-bark/20",
          closeButton:
            "group-[.toast]:bg-shire-bark/10 group-[.toast]:text-shire-bark group-[.toast]:border-0 group-[.toast]:hover:bg-shire-bark/20 group-[.toast]:rounded-full",
          title:
            "group-[.toast]:text-shire-dark group-[.toast]:font-ui group-[.toast]:font-semibold",
          icon: "group-[.toast]:text-shire-pine",
          success:
            "group-[.toast]:bg-shire-moss/20 group-[.toast]:border-shire-pine group-[.toast]:text-shire-dark",
          error:
            "group-[.toast]:bg-shire-rose/20 group-[.toast]:border-shire-rose group-[.toast]:text-shire-dark",
          warning:
            "group-[.toast]:bg-shire-sun/20 group-[.toast]:border-shire-sun group-[.toast]:text-shire-dark",
          info: "group-[.toast]:bg-shire-stone/50 group-[.toast]:border-shire-bark group-[.toast]:text-shire-dark",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
